import toast from "react-hot-toast";
import * as api from "../Api";
import { errorText } from "./Insurance";
import { getAllUnapprovedInsurance } from "./unApprovedInsurance";

// Resolves true when saved, so the form knows whether to close
export const renewInsurance = (postData) => async (dispatch) => {
  const renewingId = toast.loading("Renewing insurance...");
  try {
    await api.createInsurance(postData);
    const message =
      "Insurance renewed. It takes effect after approval.";
    dispatch({ type: "RENEW_INSURANCE", payload: message });
    dispatch(getAllUnapprovedInsurance());
    toast.success(message, { id: renewingId });
    return true;
  } catch (error) {
    toast.error(errorText(error), { id: renewingId });
    return false;
  }
};

export const getAllRenewInsurance = () => async (dispatch) => {
  try {
    const { data } = await api.renewInsurance();
    dispatch({ type: "GET_CURRENT_INSURANCE", payload: data });
  } catch (error) {
    dispatch({ type: "LOAD_FAILED", failed: "GET_CURRENT_INSURANCE" });
  }
};
